var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { OnInit } from '@angular/core';
import { CommunicationService } from '../../../services/communication.service';
import { SCREEN_SIZE } from '../../../classes/enums';
import { HasSubscriptions } from '../../../components/has-subscriptions';
import { InternalLinksService } from '../../../services/internalLinks.service';
import { TranslateService } from '@ngx-translate/core';
import { environment } from '../../../../environments/environment-wrapper';
import { LandingPagePopularCities } from '../../../app-config.constants';
var CmsLinksComponent = /** @class */ (function (_super) {
    __extends(CmsLinksComponent, _super);
    function CmsLinksComponent(communicationService, internalLinksService, translateService) {
        var _this = _super.call(this) || this;
        _this.communicationService = communicationService;
        _this.internalLinksService = internalLinksService;
        _this.translateService = translateService;
        _this.showNew = false;
        _this.isLDP = false;
        _this.isLandingPage = false;
        _this.endpoint = environment.cdnServerUrl;
        // Enums
        _this.SCREEN_SIZE = SCREEN_SIZE;
        _this.showMore = false;
        // local assignemnt to allow the template to access this imported constant
        _this.popularCities = LandingPagePopularCities;
        _this.newestLinks = [
            'Page 1',
            'Page 2',
            'Page 3',
            'Page 4',
            'Page 5',
            'Page 6',
            'Page 7',
            'Page 8',
            'Page 9',
            'Page 10',
            'Page 11',
            'Page 12'
        ];
        return _this;
    }
    CmsLinksComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.addSub(this.communicationService.screenSize.subscribe(function (s) { return (_this.screenSize = s); }));
        this.addSub(this.communicationService.footerLinksChange.subscribe(function (place) {
            _this.getFooterLinks(place, _this.communicationService.listings.currentShownListingType.value);
        }));
    };
    CmsLinksComponent.prototype.getFooterLinks = function (place, listingCategory) {
        var _this = this;
        this.addSub(this.translateService
            .get('relevant-links.explore-links')
            .subscribe(function (title) {
            _this.title = title;
        }));
    };
    CmsLinksComponent.prototype.formatCondoUrl = function (url) {
        var fragments = url.split('/');
        var index = fragments.indexOf('luxury');
        if (index !== -1) {
            fragments.splice(index, 1);
            return fragments.join('/');
        }
        return url;
    };
    CmsLinksComponent.prototype.toggleShowMore = function () {
        this.showMore = !this.showMore;
    };
    return CmsLinksComponent;
}(HasSubscriptions));
export { CmsLinksComponent };
